enum ValidateUserSourceDialogFields {
	USER = "user"
}

export default ValidateUserSourceDialogFields;